import React from "react";
import { HeroBackgroundImage, HeroVideoContainer } from "./LandingPage.styles";
import heroBackgroundUrl from "../../../assets/ggc-hero-background.png";

/** Full-bleed static hero background (panoramic art). */
const HeroBackgroundVideo = () => (
  <HeroVideoContainer aria-hidden>
    <HeroBackgroundImage $url={heroBackgroundUrl} />
  </HeroVideoContainer>
);

export default HeroBackgroundVideo;
